import type { ReactElement } from 'react';

import { ExtraFeatureRouteGuard } from './ExtraFeatureRouteGuard';
import type { ExtraFeature } from './extraFeatures';

type ExtraFeatureRouteElementParams = {
  element: ReactElement | undefined;
  requiredExtraFeature: ExtraFeature | undefined;
  fallbackPath: string;
};

export function getExtraFeatureRouteElement({
  element,
  requiredExtraFeature,
  fallbackPath,
}: ExtraFeatureRouteElementParams): ReactElement | undefined {
  if (!element || !requiredExtraFeature) {
    return element;
  }

  return (
    <ExtraFeatureRouteGuard requiredExtraFeature={requiredExtraFeature} fallbackPath={fallbackPath}>
      {element}
    </ExtraFeatureRouteGuard>
  );
}
